export enum StoryPlaqueActivationStatusEnum
{
    New = 84,
    Active = 85,
    Customize = 133,
}